module.exports = __webpack_public_path__ + "img/DE04085.ebf45059.png";